import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP } from "../mock";
import TermsModal from "./TermsModal";

export default function Footer() {
  const { t, S, lang } = useLang();
  const [termsOpen, setTermsOpen] = useState(false);
  const year = new Date().getFullYear();
  const links = [
    { id: "servicios", label: t(S.nav.services) },
    { id: "destinos", label: t(S.nav.destinations) },
    { id: "tarifas", label: t(S.nav.transfers) },
    { id: "experiencias", label: t(S.nav.experiences) },
    { id: "contacto", label: t(S.nav.contact) },
  ];
  const waLink = `https://wa.me/${WHATSAPP}`;

  return (
    <footer className="bg-[#042f37] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-10 h-10 rounded-xl bg-accent text-accent-foreground font-display font-extrabold">X</span>
              <div className="leading-none">
                <span className="font-display font-extrabold text-lg">XPERIENCIAS</span>
                <span className="block text-[11px] tracking-[0.22em] font-semibold text-accent">MEXICO</span>
              </div>
            </div>
            <p className="mt-4 text-white/70 text-sm max-w-xs leading-relaxed">{t(S.footer.tagline)}</p>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">{t(S.nav.services)}</h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-white/70 text-sm hover:text-accent transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">{t(S.contact.title)}</h4>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold bg-[#25D366] hover:bg-[#20bd5a] text-white px-4 py-2.5 rounded-full transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-center text-white/60 text-sm">
          <span>© {year} XPERIENCIAS MEXICO. {t(S.footer.rights)}</span>
          <button
            onClick={() => setTermsOpen(true)}
            className="text-white/70 hover:text-accent transition-colors font-medium"
          >
            {lang === "es" ? "Términos y Condiciones" : "Terms & Conditions"}
          </button>
        </div>
      </div>

      <TermsModal open={termsOpen} onOpenChange={setTermsOpen} />
    </footer>
  );
}
